// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"83c04237","879":"c55cea4c"}[chunkId] + ".chunk.js";
};